import React from 'react';

export const Privacy = () => {
  return (
    <div className="pt-20">
      <section className="relative py-24 bg-gradient-to-br from-[var(--verdigris)] to-[var(--verdigris-dark)] text-white overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-20 right-20 w-96 h-96 bg-white rounded-full blur-3xl animate-float"></div>
        </div>
        <div className="absolute inset-0 pattern-dots opacity-20"></div>
        <div className="container relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 animate-fade-in">Privacy Policy</h1>
            <p className="text-lg md:text-xl text-white/90 animate-fade-in leading-relaxed" style={{ animationDelay: '0.1s' }}>
              Informativa sul trattamento dei dati personali
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border-2 border-gray-100" data-testid="privacy-content">
              <p className="text-lg text-[var(--text-light)] leading-relaxed text-center">
                La Privacy Policy completa verr&agrave; pubblicata a breve tramite Iubenda.
              </p>
              <p className="text-base text-[var(--text-light)] leading-relaxed text-center mt-4">
                Per qualsiasi domanda relativa al trattamento dei tuoi dati personali, contattaci a{' '}
                <a href="mailto:firm.recupero@gmail.com" className="text-[var(--copper-primary)] hover:text-[var(--copper-dark)] underline font-medium">
                  firm.recupero@gmail.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
